import { isNewMemberSearchEnabled } from "../../../Enums/LegacyRedirection";
import MemberSearchLegacy from "./MemberSearchLegacy";
import MemberSearchModern from "./MemberSearchModern";

const MemberSearch = () =>
  isNewMemberSearchEnabled() ? <MemberSearchModern /> : <MemberSearchLegacy />;

export default MemberSearch;
